// توحيد الدور الفعلي (hierarchy_role أو role القديم) + ترتيب التسلسل + لون البانر لكل دور.
const CANON = {
  company_admin: "company_admin", admin: "company_admin",
  system_admin: "system_admin",
  branch_manager: "branch_manager", manager: "branch_manager",
  hr: "employee", employee: "employee",
};

export const canonRole = (e) => CANON[e?.hierarchy_role || e?.role] || "employee";

const RANK = { company_admin: 0, system_admin: 1, branch_manager: 2, employee: 3 };
export const roleRank = (e) => RANK[canonRole(e)] ?? 99;

// بانر برغندي للمدير، أزرق للنظام/الأدمن، بنفسجي لمدير الفرع، أخضر للموظف.
const BANNER = {
  company_admin: "bg-[#7a1f38]",
  system_admin: "bg-blue-600",
  branch_manager: "bg-violet-600",
  employee: "bg-emerald-600",
};
export const roleBanner = (e) => BANNER[canonRole(e)] || "bg-emerald-600";
